import { SVGProps } from 'react';

export const LowPriority = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="19"
    height="18"
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.5859 10H2.58594V8H16.5859V10Z"
      fill="currentColor"
    />
  </svg>
);
